import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from "moment";
import pick from 'lodash.pick';

import {Col, Row} from "reactstrap";
import {Field, reduxForm} from "redux-form";

import {DateField, InputField, SelectField} from "../../../../../validation/ReduxFormInput";

import {normalizePhone} from "../../../../../util/normalizers";
import {educationLevels} from "../../../../../util/FormConstants";
import {handleSubmitBasic} from "../../../actions/application";
import PolyUtil from "../../../../../util/PolyUtil";

class BasicsForm extends Component {
    render() {
        const {handleSubmit} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12} sm={4}><Field name="first_name" label="First Name" component={InputField}/></Col>
                    <Col xs={12} sm={4}><Field name="middle_name" label="Middle Name" component={InputField}/></Col>
                    <Col xs={12} sm={4}><Field name="last_name" label="Last Name" component={InputField}/></Col>
                </Row>
                <Row>
                    <Col xs={12} sm={4}>
                        <Field name="phone"
                               label="Primary Phone"
                               component={InputField}
                               placeholder="555-555-5555"
                               normalize={normalizePhone}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <Field name="birth_date"
                               label="Date of Birth"
                               style={{height: "calc(2.428rem + 2px)"}}
                               component={DateField}/>
                    </Col>
                    <Col xs={12} sm={4}>
                        <Field name="highest_education_level" label="Highest Level of Education" component={SelectField} options={educationLevels}/>
                    </Col>
                </Row>
            </form>
        );
    }
}

const validate = values => {
    const errors = {};

    !values.first_name && (errors.first_name = 'Required');
    !values.last_name && (errors.last_name = 'Required');
    !values.email && (errors.email = 'Required');
    !values.phone && (errors.phone = 'Required');
    (values.phone && values.phone.length !== 12) && (errors.phone = 'Please enter a valid phone number');
    !values.birth_date && (errors.birth_date = 'Required');
    (!!values.birth_date && values.birth_date.isAfter(moment())) && (errors.birth_date = "You can't be born in the future");

    (!values.highest_education_level || values.highest_education_level === 'default') && (errors.highest_education_level = 'Required');

    return errors;
};

const submit = (data, dispatch, props) => {
    return dispatch(handleSubmitBasic(Object.assign({}, data, {
        email: props.email
    })));
};

BasicsForm = reduxForm({
    form: 'application_basic',
    onSubmit: submit,
    validate
})(BasicsForm);

const mapStateToProps = (state) => {
    let initial = state.tenant.application.is_basic_complete ? Object.assign({}, pick(state.tenant.application, [
            'first_name',
            'middle_name',
            'last_name',
            'email',
            'phone',
            'highest_education_level',
            'birth_date'
        ]
    )) : Object.assign({}, pick(state.activeUser, [
        'first_name',
        'last_name',
        'phone',
        'email'
    ]));

    initial.phone && (initial.phone = PolyUtil.formatPhone(initial.phone));
    initial.birth_date && (initial.birth_date = moment(initial.birth_date));

    return {
        email: state.activeUser.email,
        initialValues: initial
    };
};

export default connect(mapStateToProps)(BasicsForm);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/forms/BasicsForm.js